// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WUOTC","rootNoMargin":"styles_rootNoMargin__JTNHl"};